module.exports = __webpack_public_path__ + "img/Qhearts.1526225e.jpg";